import * as XLSX from "xlsx";
import moment from "moment";
import func from "../../../services/functions";

const exportXlsx = (data, columns, reportTitle) => {
  if (!data || data.length === 0) return;

  const formattedData = data.map((row) => {
    const obj = {};
    columns.forEach((col) => {
      const value = row[col.field];
      obj[col.header] = col.isMoney
        ? `${func.getFormattedMoneyValue(value)} L`
        : value ?? "";
    });
    return obj;
  });

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, reportTitle.slice(0, 31));

  const fileName = `${reportTitle.replace(/\s+/g, "_")}_${moment().format("YYYY-MM-DD")}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};

export default exportXlsx;
